<template>
  <div class="video-card" @click="handleClick">
    <div class="video-card__thumbnail">
      <img :src="video.thumbnailUrl" :alt="video.title" @error="onImageError">
    </div>
    <div class="video-card__content">
      <h3 class="video-card__title">{{ video.title }}</h3>
      <p class="video-card__date">{{ video.subtitle }}</p>
<!--      <p class="video-card__date">{{ video.publishDate }}</p>-->
    </div>
  </div>
</template>

<script>
import placeholder from '@/assets/images/video-placeholder.svg';

export default {
  name: 'VideoCard',
  props: {
    video: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleClick() {
      this.$emit('click', this.video);
    },
    onImageError(e) {
      if (e && e.target && e.target.src !== placeholder) {
        e.target.src = placeholder;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.video-card {
  cursor: pointer;
  margin-bottom: 30px;
  transition: transform 0.2s;

  &:hover {
    transform: translateY(-2px);
  }
}

.video-card__thumbnail {
  width: 100%;
  //width: 100%;

  position: relative;
  overflow: hidden;
  margin-bottom: 15px;
  background-color: #f0f0f0;

  img {
    width: 100%;
    height: auto;
    display: block;
  }
}

.video-card__content {
  text-align: left;
}

.video-card__title {
  font-size: 20px;
  font-weight: 700;
  color: #222;
  line-height: 1.5;
  word-break: keep-all;
  margin-bottom: 8px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.video-card__date {
  font-size: 16px;
  color: #999;
  line-height: 1.4;
}
</style>